import { ReactElement, ReactNode } from 'react';

import styled from 'styled-components';

import { IconProps } from '@components/icons';
import { Stack } from '@components/stack';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type FilterListItemProps = {
  selectionIcon?: ReactElement<IconProps>;
  icon?: ReactElement<IconProps>;
  label: ReactNode;
  onClick(): void;
  isHeading?: boolean;
  isActive?: boolean;
};

export const FilterListItem = ({
  onClick,
  icon,
  label,
  isHeading = false,
  isActive = false,
  selectionIcon,
}: FilterListItemProps) => {
  return (
    <StyledMenuItem onClick={onClick} $isHeading={isHeading} $isActive={isActive}>
      {selectionIcon}
      <Stack space={1} orientation="horizontal" align="center">
        {icon}
        <LabelText>{label}</LabelText>
      </Stack>
    </StyledMenuItem>
  );
};

const StyledMenuItem = styled.li<{ $isHeading?: boolean; $isActive?: boolean }>((props) => ({
  minHeight: theme.base.height,
  flexShrink: 0,
  font: props.$isHeading ? theme.font.bold14 : theme.font.regular14,
  display: 'flex',
  alignItems: 'center',
  color: props.$isActive ? theme.color.elementBlue100 : theme.color.textPrimary,
  padding: pxToRem(8),
  cursor: 'pointer',
  borderRadius: pxToRem(4),
  gap: pxToRem(8),

  svg: {
    color: `var(--icon-color, ${theme.color.elementPurple80})`,
    flexShrink: 0,
  },

  '&:hover': {
    backgroundColor: theme.color.uiTrans5,
  },
}));

const LabelText = styled.span({
  maxWidth: pxToRem(224),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
